import { useState, useCallback } from "react";
import { api } from "../lib/api";
import type { VanityLink, VanityLinkWrite } from "../../api/_lib/types";

export function useLinks() {
  const [links, setLinks] = useState<VanityLink[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.links.list();
      setLinks(data.sort((a, b) => b.createdAt - a.createdAt));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (data: VanityLinkWrite) => {
    const { slug, ...rest } = data;
    await api.links.create({ slug, ...rest });
    await load();
  }, [load]);

  const update = useCallback(async (slug: string, data: Partial<Omit<VanityLinkWrite, "slug">>) => {
    await api.links.update(slug, data);
    await load();
  }, [load]);

  const remove = useCallback(async (slug: string) => {
    await api.links.delete(slug);
    setLinks(prev => prev.filter(l => l.slug !== slug));
  }, []);

  return { links, loading, error, load, create, update, remove };
}
